import createVuexModule from '~/store/utils/createVuexModule';
import type { PaymentSelectedState } from '~/types/vuex/PaymentSelected';
import CustomPayment from '~/constants/customPayment';

export default createVuexModule<PaymentSelectedState['paymentSelected']>({
  stateKey: 'paymentSelected',
  initialValue: CustomPayment.ADYEN,
  mutationName: 'setPaymentSelected',
});
